//@ts-nocheck
import React, { useEffect } from "react";
import Svg from "../../Svg/Svg";
import InputWrapper from "../../InputWrapper/InputWrapper";
import OccupiedField from "../OccupiedField/OccupiedField";
import { TextFieldWrapper, FieldWrapper, FieldActionWrapper } from "@factorearth/component-library";
import { useState } from "react";
import { recordSentry } from "utils/recordSentry";
import { useErrorBoundary } from "react-error-boundary";
/**
 * Text Field Type Component
 * @param {Object} color configuration data.
 * @param {FieldInstance} fieldInstance the field template data combined with the instance
 * @param {FieldTemplate} fieldTemplate the field template for the instance using this field type
 * @param {mixed} value the value of the field
 * @param {Function} handleChange the on change call back
 * @param {Function} onBlur the on blur callback
 * @param {Boolean} fromTable true if the field is inside a table for css stuff
 */
function TextField(props) {
	const {
		color,
		fieldInstance,
		fieldInstanceId,
		activeEditing,
		fieldTemplate,
		value,
		handleChange,
		onBlur,
		handleFocus,
		fromTable,
		username,
		authUsername,
		handleHistory,
		user,
		moreHorizon,
	} = props;

	const [currentValue, setCurrentValue] = useState(value);

	const { showBoundary } = useErrorBoundary();

	useEffect(() => {
		setCurrentValue(value);
	}, [value]);

	const handleInputChange = (e) => {
		// This is for fixing undo/redo issue
		setCurrentValue(e.target.value);
		handleChange(e);
	};

	/**
	 * on blur handler
	 * @param {Object} e event object
	 */
	function handleBlur(e) {
		try {
			onBlur();
		} catch (error) {
			recordSentry({ error, msg: "TextField onBlur Failed" });
			showBoundary(error);
		}
	}

	return (
		<FieldWrapper
			colorPalette={color}
			label={!fromTable ? fieldTemplate.header : undefined}
			link={fieldInstance.altInstanceId ? <Svg icon="LINKED" /> : undefined}
			data-test={"Field-Header"}>
			{username && username !== authUsername ? (
				<OccupiedField username={username} moreHorizon={moreHorizon} />
			) : (
				<FieldActionWrapper>
					<TextFieldWrapper
						colorPalette={color}
						data-test="input-wrap"
						type="text"
						value={currentValue}
						onChange={handleInputChange}
						onFocus={handleFocus}
						tabIndex={0}
						onBlur={handleBlur}
						placeholder={fieldTemplate.placeholder || (fromTable ? fieldTemplate.header : "")}
						activeEditing={activeEditing}
						moreHorizon={moreHorizon ? moreHorizon : undefined}
						data-fieldtemplateid={fieldTemplate.id}
						unigueid={fieldInstanceId}
					/>
				</FieldActionWrapper>
			)}
		</FieldWrapper>
	);
}

export default TextField;
